import React from "react";

import { useGetFootprintingCropPrimaryDataById, useGetPracticeCrop, useTranslation } from "utils";

import { AlertBanner, Card, Flex, Icon, PageSpin, Tag, Typography } from "components";

interface CropGettingStartedProps {
  primaryDataId?: string;
  cropId?: string;
}

const INFO_ITEMS = [
  "cropGettingStartedForm.info.gain",
  "cropGettingStartedForm.info.breakdown",
  "cropGettingStartedForm.info.compare",
  "cropGettingStartedForm.info.discover",
  "cropGettingStartedForm.info.track",
];

const CROP_LIST_FILES = ["fieldManagementDocumentation", "cropDryingDocumentation", "yieldDocumentation", "fertilizerDocumentation", "fieldSizeInfo"];

const CropGettingStartedForm = ({ primaryDataId, cropId }: CropGettingStartedProps) => {
  const { t } = useTranslation("footprintingCrop");

  const cropPrimaryData = useGetFootprintingCropPrimaryDataById(primaryDataId ?? "");
  const cropInfo = useGetPracticeCrop(cropId);

  if ((primaryDataId && cropPrimaryData.isLoading) || !cropInfo) return <PageSpin />;

  // const cropImagePath = cropInfo?.imageURL
  //   ? cropInfo?.imageURL?.replace("small", "big")
  //   : "https://klimpublic.s3.eu-central-1.amazonaws.com/footprinting-crop-images/big/placeholder.webp";

  return (
    <Flex vertical gap={16}>
      <Card border className="padding-200">
        {/* TODO: Replace with non-AI images */}
        {/* <Flex gap="1rem" vertical>
          <LazyLoadImage alt={`${cropInfo.name || "Crop"} image`} aria-label={`${cropInfo.name || "crop"}-logo-image`} src={cropImagePath} />
        </Flex> */}
        <Flex gap={8} vertical>
          {INFO_ITEMS.map((item) => (
            <Flex key={item} align="center" gap={8}>
              <Icon size={24} iconName="tabler/circle-check" className="input-label-info-icon margin-left-0" />
              <Typography variant="paragraph-m">{t(item)}</Typography>
            </Flex>
          ))}
        </Flex>
      </Card>

      <Card border>
        <Flex vertical gap={24} className="padding-200">
          <Flex vertical gap={4}>
            <Flex justify="space-between" align="center">
              <Typography variant="h3">{t("cropGettingStartedForm.documents")}</Typography>
              <Tag size="large" text={t("cropGettingStartedForm.tag")} className="center" />
            </Flex>
            <Typography variant="paragraph-m" color="grey-600" className="margin-0">
              {t("cropGettingStartedForm.documentsDescription")}
            </Typography>
          </Flex>

          <Flex vertical gap={4}>
            {CROP_LIST_FILES.map((file) => (
              <div key={file}>
                <Typography variant="paragraph-m" className="margin-right-50">
                  •
                </Typography>
                <Typography variant="paragraph-m">{t(`cropGettingStartedForm.cropListFiles.${file}`)}</Typography>
              </div>
            ))}
          </Flex>

          <AlertBanner
            headingSize="h6"
            gap={12}
            title={t("cropGettingStartedForm.alertBanner.title")}
            description={t("cropGettingStartedForm.alertBanner.description")}
            iconName="tabler/bulb"
            iconSize={24}
            type="recommended"
            iconAlign="start"
          />
        </Flex>
      </Card>

      <AlertBanner
        headingSize="h6"
        gap={12}
        title={t("cropGettingStartedForm.infoBanner.title")}
        description={t("cropGettingStartedForm.infoBanner.description")}
        iconName="tabler/info-circle"
        iconSize={24}
        type="info"
        iconAlign="start"
      />
    </Flex>
  );
};

CropGettingStartedForm.Key = "crop.gettingStarted";
export { CropGettingStartedForm };
